module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-buttons"
  }, [(!_vm.isJoined) ? [_c('div', {
    staticClass: "card-btn__copy"
  }, [_vm._v("\n            Join SK Club now to activate your SK Club\n            Standard Bank 4FOR3 Benefit.\n        ")]), _vm._v(" "), (_vm.moreInfoLink) ? _c('div', {
    staticClass: "card-btn__copy"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "block": "",
      "tag": "a",
      "href": _vm.moreInfoLink,
      "target": "_blank"
    }
  }, [_vm._v("More Info")])], 1) : _vm._e(), _vm._v(" "), (_vm.activationLink) ? _c('div', {
    staticClass: "card-btn__copy"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "block": "",
      "tag": "a",
      "href": _vm.activationLink,
      "target": "_blank"
    }
  }, [_vm._v("Get A\n                Card\n            ")])], 1) : _vm._e()] : (_vm.isJoined && _vm.isLinked) ? [_c('div', {
    staticClass: "membership"
  }, [
    [_vm._v("\n                Book a movie now and get 4 tickets for the price of 3 when paying with any Standard Bank Credit Card.\n            ")]
  ], 2)] : [_c('sk-form', {
    attrs: {
      "id": "link-card-form-sk-club"
    },
    on: {
      "submit": function($event) {
        _vm.onLink(_vm.thisCardNumber)
      }
    }
  }, [(!_vm.isLinked) ? _c('div', {
    staticClass: "card-btn__copy"
  }, [_vm._v("\n                Have a Standard Bank Credit Card? Activate this\n                exclusive benefit by entering your ID number now.\n            ")]) : _vm._e(), _vm._v(" "), [(!_vm.isLinked) ? [_c('div', {
    staticClass: "card-btn__copy"
  }, [_c('sk-input', {
    attrs: {
      "placeholder": "ID Number",
      "required": ""
    },
    model: {
      value: (_vm.thisCardNumber),
      callback: function($$v) {
        _vm.thisCardNumber = $$v
      },
      expression: "thisCardNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-btn__copy"
  }, [_c('sk-button', {
    attrs: {
      "primary": "",
      "block": "",
      "type": "submit",
      "loading": _vm.linking
    }
  }, [_vm._v("\n                            Activate\n                        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "card-btn__copy"
  }, [_c('sk-button', {
    attrs: {
      "secondary": "",
      "block": "",
      "tag": "a",
      "href": "https://www.standardbank.co.za/southafrica/personal/products-and-services/bank-with-us/credit-cards/our-cards",
      "target": "_blank"
    }
  }, [_vm._v("\n                            Get A Card\n                        ")])], 1)] : _vm._e()]], 2)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06177e18","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/card/card-sb4for3.vue
// module id = 879
// module chunks = 0